import { RouteEntry } from "../../shared/routes";
import { Home } from "./Home";

export const homeRoutes: Array<RouteEntry> = [
    { path: '/', exact: true, component: Home, authorize: false },

];
